import {
  UserMemberships,
  SubscriptionManagement,
} from './subscriptionsManagementTypes';
import {
  SubscriptionsManagementThunk,
  SUBSCRIPTIONS_MANAGEMENT_SET_SUBSCRIPTIONS,
  SUBSCRIPTIONS_MANAGEMENT_SET_SUBSCRIPTIONS_MAP,
  SUBSCRIPTIONS_MANAGEMENT_SET_USER_SUBSCRIPTIONS,
  subscriptionsManagementSetSubscriptionsActionType,
  subscriptionsManagementSetSubscriptionsMapActionType,
  subscriptionsManagementSetUserSubscriptionsActionType,
} from './subscriptionsManagementActionTypes';
import { EventThunkAction } from '../events/eventActionTypes';
import { startLoaderThunk, stopLoaderThunk } from '../modal/modalActions';
import { NavigationEnum } from '../../navigation/vertical/Navigation.enum';
import { SUBSCRIPTIONS_MANAGEMENT_NAMESPACE } from './subscriptionsManagementReducer';
import { MembershipDates } from '../../utility/functions/setEventPriceFromMembership';
import {
  CreditBalanceDto,
  PurchaseSubscriptionRequestDto,
} from '../../API/subsription-management/dto/request/purchase-subscription.request.dto';
import SubscriptionManagementApi from '../../API/subsription-management/SubscriptionManagement.api';

export function subscriptionsManagementSetSubscriptionsAction(
  subscriptions: SubscriptionManagement[]
): subscriptionsManagementSetSubscriptionsActionType {
  return {
    type: SUBSCRIPTIONS_MANAGEMENT_SET_SUBSCRIPTIONS,
    payload: subscriptions,
  };
}

export function subscriptionsManagementSetSubscriptionsMapAction(
  subscriptionMap: Map<number, MembershipDates[]>
): subscriptionsManagementSetSubscriptionsMapActionType {
  return {
    type: SUBSCRIPTIONS_MANAGEMENT_SET_SUBSCRIPTIONS_MAP,
    payload: subscriptionMap,
  };
}

export function subscriptionsManagementSetUserSubscriptionsAction(
  subscriptions: UserMemberships[]
): subscriptionsManagementSetUserSubscriptionsActionType {
  return {
    type: SUBSCRIPTIONS_MANAGEMENT_SET_USER_SUBSCRIPTIONS,
    payload: subscriptions,
  };
}

export function subscriptionsManagementSetSubscriptionsThunk(): SubscriptionsManagementThunk<
  Promise<void>
> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    return SubscriptionManagementApi.getAllSubscriptions()
      .then((response) => {
        dispatch(
          subscriptionsManagementSetSubscriptionsAction(
            response.data.subscriptionsResponse
          )
        );
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function subscriptionsManagementSetUserSubscriptionsThunk(
  forceRefresh = false
): SubscriptionsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    if (
      !getState()[SUBSCRIPTIONS_MANAGEMENT_NAMESPACE].user.isInit ||
      forceRefresh
    ) {
      const response =
        await SubscriptionManagementApi.getAllUserSubscriptions();
      dispatch(
        subscriptionsManagementSetUserSubscriptionsAction(
          response.data.membershipsResponse
        )
      );

      const membershipsMap = new Map<number, MembershipDates[]>();
      for (const membership of response.data.membershipsResponse) {
        for (const category of membership.subscription.categoryObjects) {
          const dates = {
            fromDate: membership.fromDate,
            toDate: membership.toDate,
          };
          const categoryMapItem = membershipsMap.get(category.id);
          if (categoryMapItem) {
            categoryMapItem.push(dates);
          } else {
            membershipsMap.set(category.id, [dates]);
          }
        }
      }

      dispatch(
        subscriptionsManagementSetSubscriptionsMapAction(membershipsMap)
      );
    }

    return dispatch(stopLoaderThunk());
  };
}

export function PurchaseSubscriptionThunk(
  subscription: SubscriptionManagement,
  fromWhichPage: NavigationEnum
): SubscriptionsManagementThunk<
  Promise<{ isPaid: boolean; paymentProcessLink?: string; orderId: number }>
> {
  return async (dispatch, getState) => {
    const creditState = getState()['CREDITS_NAMESPACE'];
    const authState = getState()['AUTH_NAMESPACE'];
    const creditCardsState = getState()['CREDIT_CARDS_NAMESPACE'];

    dispatch(startLoaderThunk()).finally();

    const newData: PurchaseSubscriptionRequestDto = {
      user_id: authState.profile?.id!,
      subscription_id: subscription.id,
      from_date: +subscription.fromDate,
      to_date: +subscription.toDate,
    };

    const creditBalance: CreditBalanceDto = {
      credit_payments: [],
      cash_amount: creditState.creditInUse?.cashAmount || null,
      credit_card_id: creditCardsState.selectedCreditCard?.id,
      save_credit_card: creditCardsState.saveCreditCard,
    };

    try {
      const response = await SubscriptionManagementApi.purchaseSubscription(
        newData,
        creditBalance
      );

      await dispatch(subscriptionsManagementSetUserSubscriptionsThunk());

      return {
        isPaid: response?.data?.paymentsProcess?.isPaid,
        paymentProcessLink: response.data.paymentsProcess.paymentProcessLink,
        orderId: response.data.id,
      };
    } finally {
      await dispatch(stopLoaderThunk());
    }
  };
}

export function CancelMembershipThunk(
  membershipId: number
): EventThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    try {
      await SubscriptionManagementApi.cancelMembership(membershipId);
    } finally {
      dispatch(stopLoaderThunk()).finally();
    }
  };
}
